import { render, staticRenderFns } from "./AngleDiagramBox.vue?vue&type=template&id=79dcd1d8&scoped=true&"
import script from "./AngleDiagramBox.vue?vue&type=script&lang=ts&"
export * from "./AngleDiagramBox.vue?vue&type=script&lang=ts&"
import style0 from "./AngleDiagramBox.vue?vue&type=style&index=0&id=79dcd1d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dcd1d8",
  null
  
)

export default component.exports